const Fez = window.Fez;
if (!Fez) throw new Error('fez runtime not loaded: load fez (window.Fez) before component modules');

// --- ui-card ---
let __fez_component_0;
{

__fez_component_0 = class {
  NAME = (node) => (node.getAttribute('href') ? 'a' : 'div')

  PROPS = {
    href: String,
    target: String,
    padding: { type: String, default: 'md', enum: ['none', 'sm', 'md', 'lg', 'xl'] },
    tone: { type: String, default: 'default', enum: ['default', 'muted', 'danger', 'dashed'] },
    interactive: Boolean,
    elevated: Boolean,
  }

  // Renders once (slot unwrap); a changed prop or content rebuilds the card.
  // The look is the global `.ui-card` class in ui-theme.fez, shared with plain elements.
  init() {
    const { href, target, padding, tone, interactive, elevated } = this.props
    this.root.classList.add('ui-card', `pad-${padding}`, `tone-${tone}`)
    if (elevated) this.root.classList.add('elevated')
    if (href || interactive) this.root.classList.add('interactive')
    if (href) {
      this.root.setAttribute('href', href)
      if (target) this.root.setAttribute('target', target)
      if (target === '_blank') this.root.setAttribute('rel', 'noopener')
    }
  }

  HTML = `<slot unwrap />`
};
}

Fez('ui-card', __fez_component_0);

export default __fez_component_0;
